// const crimeData = []

const crimeData = [
    {
        landmark: "chorbazaar",
        type: "murder",
        severity: "high",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },
    {
        landmark: "chorbazaar",
        type: "murder",
        severity: "high",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    },
    {
        landmark: "chorbazaar",
        type: "murder",
        severity: "high",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
    }
];

const crimeTypes = [
    "murder",
    "theft",
    "Assault",
    "Child Abuse",
    "Violence",
    "Kidnapping",
    "Riots",
    "burglary",
    "cybercrime",
    "bombing",
    "forgery",
    "child trafficing",
    "genocide",
    "hit and run",
    "looting",
    "rape",
    "smuggling",
    "vandalism",
    "other"
]

export { crimeData, crimeTypes };